import { httpClient } from '../httpClient';

export const dataflowSCCApi = {
  listTemplates: () =>
    httpClient.get('/dataflow/scc/templates'),

  getTemplate: (id) =>
    httpClient.get(`/dataflow/scc/templates/${id}`),

  listAssignments: (params) =>
    httpClient.get('/dataflow/scc/assignments', { params }),

  createAssignment: (data) =>
    httpClient.post('/dataflow/scc/assignments', data),

  updateAssignment: (id, data) =>
    httpClient.put(`/dataflow/scc/assignments/${id}`, data),

  signAssignment: (id, data) =>
    httpClient.put(`/dataflow/scc/assignments/${id}/sign`, data),

  terminateAssignment: (id, data) =>
    httpClient.put(`/dataflow/scc/assignments/${id}/terminate`, data),

  getExpiringAssignments: (days) =>
    httpClient.get('/dataflow/scc/assignments/expiring', { params: { days } }),

  bulkGenerate: (data) =>
    httpClient.post('/dataflow/scc/assignments/bulk-generate', data),

  getDocument: (id) =>
    httpClient.get(`/dataflow/scc/assignments/${id}/document`),
};
